// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__199ZM","title":"styles_title__Oojw2"};